/** Connexion / création de compte / déconnexion. */
import { useState } from 'react';
import type { User } from '@supabase/supabase-js';
import { signIn, signUp, signOut } from '../lib/supabase';

interface Props {
  user: User | null;
  onClose: () => void;
  onOpenLibrary: () => void;
}

export default function AccountModal({ user, onClose, onOpenLibrary }: Props) {
  const [mode, setMode] = useState<'in' | 'up'>('in');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const err = mode === 'in' ? await signIn(email, password) : await signUp(email, password);
    setBusy(false);
    if (err) setError(err);
    else if (mode === 'up') setError(null); // connecté dans la foulée (auto-confirm)
  };

  return (
    <div className="modal-scrim" onClick={onClose}>
      <div className="modal" role="dialog" aria-label="Compte" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <strong>👤 {user ? 'Mon compte' : mode === 'in' ? 'Se connecter' : 'Créer un compte'}</strong>
          <button className="btn xs ghost" onClick={onClose} aria-label="Fermer">✕</button>
        </div>

        {user ? (
          <>
            <p className="note">Connecté : <strong>{user.email}</strong></p>
            <button className="btn block" onClick={() => { onOpenLibrary(); }}>📚 Ma bibliothèque</button>
            <button className="btn ghost block" onClick={() => { void signOut(); onClose(); }}>Se déconnecter</button>
          </>
        ) : (
          <form onSubmit={submit} className="account-form">
            <input
              className="field" type="email" placeholder="Email" value={email} required
              autoComplete="email" onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="field" type="password" placeholder="Mot de passe (6 caractères min.)" value={password} required minLength={6}
              autoComplete={mode === 'in' ? 'current-password' : 'new-password'}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <p className="account-error" role="alert">{error}</p>}
            <button className="btn primary block" type="submit" disabled={busy}>
              {busy ? '…' : mode === 'in' ? 'Se connecter' : 'Créer mon compte'}
            </button>
            <button
              className="btn ghost block" type="button"
              onClick={() => { setMode(mode === 'in' ? 'up' : 'in'); setError(null); }}
            >
              {mode === 'in' ? 'Pas encore de compte ? En créer un' : 'Déjà un compte ? Se connecter'}
            </button>
            <p className="note">Ton compte garde tes prises et tes projets pour les retrouver sur tous tes appareils.</p>
          </form>
        )}
      </div>
    </div>
  );
}
